export const BASE_URL = '/';

export const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;

export const API_URL = 'https://www.googleapis.com/books/v1/volumes';

export const PAGINATION_COUNT = 30;
